import {
    clearUamAuthToken,
    removeSpiceData,
    setAuthData,
    setGamData,
    setSpiceData,
    setUamData,
} from '../../state/ducks/auth';
import {setAssetIdList} from '../../state/ducks/usageStatistic';
import {
    selectAccessToken,
    selectAccessTokenData,
    selectAuthUsername,
    selectRefreshToken,
    selectSpiceToken,
} from '../../state/selectors/auth';
import {dispatch, getState} from '../../state/store';
import userSessionService from '../user/userSessionService';

const getAccessToken = () => selectAccessToken(getState());
const getAccessTokenData = () => selectAccessTokenData(getState());
const getAuthUsername = () => selectAuthUsername(getState());
const getRefreshToken = () => selectRefreshToken(getState());
const getSpiceToken = () => selectSpiceToken(getState());
const setUamApiData = (uamData) => dispatch(setUamData(uamData));
const setGamApiData = (isHolder, authToken) => dispatch(setGamData(isHolder, authToken));
const clearUamApiToken = (isHolder) => dispatch(clearUamAuthToken(isHolder));
const removeSpiceApiData = () => dispatch(removeSpiceData());
const setAssetIdApiList = (uamData) => dispatch(setAssetIdList(uamData));

const setIccTokenData = (data) => {
    dispatch(setAuthData(data));
    userSessionService.setUserSessionTokenData(data);
};

const setSpiceToken = (token, username) => {
    dispatch(setSpiceData(token, username));
    userSessionService.setUserSessionSpiceTokenData(token, username);
};

export default {
    clearUamApiToken,
    getAccessToken,
    getAccessTokenData,
    getAuthUsername,
    getRefreshToken,
    getSpiceToken,
    setIccTokenData,
    setSpiceToken,
    setUamApiData,
    setGamApiData,
    removeSpiceApiData,
    setAssetIdApiList,
};
